export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="terms-page">
      <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-400">Legal</div>
      <h1 className="mt-2 font-display text-4xl font-semibold tracking-tight">Terms of service</h1>
      <div className="mt-8 space-y-4 text-slate-700 leading-relaxed">
        <p>By using MyTown you agree to use the platform lawfully and in good faith. MyTown is operated by DH Website Services Ltd.</p>
        <p>MyTown acts as a discovery and booking platform between customers and local businesses. We are not a party to any contract between a business and a customer. We do not provide services ourselves.</p>
        <p>Businesses are responsible for the accuracy of their listings and the quality of their work. Customers are responsible for honouring confirmed bookings and providing accurate details.</p>
        <p>MyTown reserves the right to suspend or remove listings and accounts that breach these terms.</p>
        <p><em>Beta terms. A full agreement will be published at public launch.</em></p>
      </div>
    </div>
  );
}
